{
  "name": "llm-wiki-compiler",
  "version": "1.3.0",
  "description": "A knowledge compiler CLI — raw sources in, interlinked wiki out",
  "type": "module",
  "main": "./dist/index.js",
  "types": "./dist/index.d.ts",
  "exports": {
    ".": {
      "types": "./dist/index.d.ts",
      "import": "./dist/index.js"
    },
    "./package.json": "./package.json"
  },
  "bin": {
    "llmwiki": "dist/cli.js"
  },
  "scripts": {
    "build": "tsup",
    "dev": "tsup --watch",
    "dev:view": "node scripts/dev-viewer.mjs",
    "vendor:fonts": "node scripts/vendor-fonts.mjs",
    "release:check-docs": "node scripts/check-release-docs.mjs",
    "release:check-docs:current": "node scripts/check-release-docs.mjs --current-version",
    "test": "vitest run",
    "test:watch": "vitest",
    "typecheck:tests": "node scripts/typecheck-tests.ts",
    "typecheck:tests:update": "node scripts/typecheck-tests.ts --update",
    "fallow:ci": "bash scripts/fallow-ci.sh",
    "prepublishOnly": "npm run release:check-docs:current && npm run build && npm pack --dry-run --ignore-scripts",
    "prepare": "husky",
    "test:pack": "vitest run --config /dev/null test/sdk/packaging.test.ts"
  },
  "keywords": [
    "knowledge",
    "wiki",
    "llm",
    "compiler",
    "markdown",
    "obsidian"
  ],
  "license": "MIT",
  "author": "Ethan Joffe",
  "repository": {
    "type": "git",
    "url": "git+https://github.com/atomicstrata/llm-wiki-compiler.git"
  },
  "homepage": "https://github.com/atomicstrata/llm-wiki-compiler#readme",
  "bugs": {
    "url": "https://github.com/atomicstrata/llm-wiki-compiler/issues"
  },
  "files": [
    "dist/",
    "CHANGELOG.md",
    "LICENSE",
    "README.md"
  ],
  "engines": {
    "node": ">=24"
  },
  "dependencies": {
    "@anthropic-ai/claude-agent-sdk": "^0.3.163",
    "@anthropic-ai/sdk": "^0.101.0",
    "@modelcontextprotocol/sdk": "^1.29.0",
    "@mozilla/readability": "^0.6.0",
    "ajv": "^8.20.0",
    "canonicalize": "^3.0.0",
    "chokidar": "^4.0.0",
    "commander": "^13.0.0",
    "dotenv": "^17.4.0",
    "js-yaml": "^4.3.0",
    "jsdom": "^25.0.0",
    "markdown-it": "^14.3.0",
    "openai": "^6.42.0",
    "p-limit": "^6.0.0",
    "pdf-parse": "^2.4.5",
    "sanitize-html": "^2.17.6",
    "turndown": "^7.2.0",
    "youtube-transcript": "^1.3.1",
    "zod": "^4.4.3"
  },
  "devDependencies": {
    "@copilotkit/aimock": "^1.15.1",
    "@fontsource/dm-sans": "5.2.6",
    "@fontsource/jetbrains-mono": "^5.3.0",
    "@fontsource/nunito": "5.2.7",
    "@fontsource/space-grotesk": "^5.3.0",
    "@types/js-yaml": "^4.0.9",
    "@types/jsdom": "^21.1.0",
    "@types/markdown-it": "^14.1.2",
    "@types/sanitize-html": "^2.16.1",
    "@types/turndown": "^5.0.0",
    "fallow": "2.82.0",
    "husky": "^9.1.7",
    "madge": "^8.0.0",
    "tsup": "^8.0.0",
    "typescript": "5.9.3",
    "vitest": "^3.2.7"
  },
  "volta": {
    "node": "24.16.0"
  },
  "overrides": {
    "esbuild": "0.28.1"
  }
}
